import { Component } from '@angular/core';
import { OnboardingProvider } from 'src/providers/onboarding/onboarding.provider';
import { Util } from 'src/shared/util/util';

@Component({
    selector: 'select-restocking-option',
    templateUrl: './select-restocking-option.component.html',
    styleUrls: ['./select-restocking-option.component.scss'],
    standalone: false
})

export class SelectRestockingOptionOnboardingComponent {

  constructor(
    public onboardingProvider: OnboardingProvider,
    private util: Util
  ) {}

  goToCreateConciergeAction() {
    this.onboardingProvider.page = 'createConciergeAction';
    this.onboardingProvider.showBackButton = true;
    this.onboardingProvider.priorPages.push('inventoryAutomation');
  }

  goToUploadInventoryList() {
    this.onboardingProvider.page = 'restocking';
    this.onboardingProvider.showBackButton = true;
    this.onboardingProvider.priorPages.push('inventoryAutomation');
  }

  async prosAddFromChecklist() {
    try {
      await this.onboardingProvider.markGoalAsCompleted('inventoryAutomation');
      this.onboardingProvider.setShowOnboardingOnPage(false);
      this.onboardingProvider.setShowOnboardingInHeader(true);
    } catch (error) {
      this.util.showError('Error completing onboarding');
    }
  }

  startWithPopular() {
    this.onboardingProvider.page = 'restocking';
    this.onboardingProvider.showBackButton = true;
    this.onboardingProvider.priorPages.push('inventoryAutomation');
  }

} 